<template>
  <div id="bulletin-board">
    <div class="board-wrap">
      <div class="board-title">Announcement <span @click="jumpPage('AgtAnnouncementList')">more</span></div>
      <div class="board-text"
           v-for="item in list"
           @click="jumpPage('AgtAnnouncementDetail',item.resId)"
           :key="item.resId">
        <span class="subject"
              :title="item.subject">{{item.subject}}</span>
        <i class="icon iconfont iconnew"
           v-if="item.flag===0"></i>
      </div>
    </div>
  </div>
</template>
<script>
import './index.less';
export default {
  created() {
    this.getList();
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    async getList() {
      let params = { currPage: 1, pageSize: 6 };
      const res = await this.$api.getAnnouncementList(params);
      this.list = res.data.resultData;
    },
    jumpPage(routerName, id) {
      this.$router.push({ name: routerName, query: { resId: id } });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/global-components/BulletinBoard/index.vue